import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-center p-3">
      © {new Date().getFullYear()} Organizational Portal. All Rights Reserved.
    </footer>
  );
};

export default Footer;
